import * as React from "react";

// eslint-disable-next-line no-restricted-imports
import { useNextRibbonTabListEnabled } from "./hooks/useNextTabListExperiment";

import type { TabListProps as InternalTabListProps } from "./TabList.Props";

import { TabListWithFocusWrapper } from "./next/TabListWithFocusWrapper";
import { TabList as CurrentTabList } from "./CurrentTabList";

declare let __Delay_FluentV8__: boolean;

/**
 * Enables a component to opt out of the new FluentUI v9 tablist experience.
 * Useful in cases where a tablist relies heavily on legacy custom styling,
 * or other legacy behavior.
 */
type UseLegacyTabListProps = {
  /** Option to opt out from the new v9 tablist component */
  useLegacyTabList?: boolean;
};

const V8TabList =
  typeof __Delay_FluentV8__ === "undefined" || !__Delay_FluentV8__
    ? CurrentTabList
    : React.lazy(
        () => import(/* webpackChunkName: "commonV8" */ "./CurrentTabList")
      );

export const TabList = React.forwardRef<
  HTMLDivElement,
  InternalTabListProps & UseLegacyTabListProps
>((props, ref) => {
  const isNewTabListEnabled =
    useNextRibbonTabListEnabled() && !props.useLegacyTabList;
  return isNewTabListEnabled ? (
    <TabListWithFocusWrapper ref={ref as any} {...props} />
  ) : (
    <React.Suspense fallback={<></>}>
      <V8TabList ref={ref as any} {...props} />
    </React.Suspense>
  );
});

TabList.displayName = "TabList";

export type TabList = typeof TabList.prototype;
